// Sale helpers shared across the app.

// Returns the timestamp (ms) when a sale ends, or null if no end date.
// A pure date ("YYYY-MM-DD") is treated as valid through the WHOLE selected day.
export const getSaleEndMs = (saleEndDate) => {
  if (!saleEndDate) return null;
  const d = new Date(saleEndDate);
  if (isNaN(d.getTime())) return null;
  if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0) {
    return d.getTime() + 24 * 60 * 60 * 1000;
  }
  return d.getTime();
};

// A product is actively on sale if flagged isSale, has a salePrice, and its end date has not passed.
export const isSaleActive = (p) => {
  if (!p || !p.isSale || !p.salePrice) return false;
  const end = getSaleEndMs(p.saleEndDate);
  if (end !== null && end <= Date.now()) return false;
  return true;
};

// The price actually charged for an item (sale price when the sale is active, otherwise regular price).
export const effectivePrice = (item) => (isSaleActive(item) ? item.salePrice : item.price);
